import React from 'react';
import { FormControlLabel, Checkbox, Tooltip, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: 'white',
        color: '#3A3A3A',
        maxWidth: '520px',
        border: '1px solid #dadde9',
    },
});
/**
 * @typedef {{
 *  isActive: boolean;
 *  onChange: ?(target: string, isChecked: boolean) => void;
 *  settingNamesUsingRule: string[]?;
 * }} IsActiveCheckboxProps
 * @param {IsActiveCheckboxProps} param0 
 */
export default function IsActiveCheckbox({
    isActive,
    onChange = () => {},
    settingNamesUsingRule = [],
}) {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'settings.ruleSet.informationStep.activeRuleSection' });
    function getIsActiveTooltip() {
        const settingNamesWithQuotes = settingNamesUsingRule
        .map( n => `"${n}"`)
        .join(', ');

        if (isActive) {
            return `${t('activeTooltip')} ${settingNamesUsingRule.length ? t('usedByTooltip', { names: settingNamesWithQuotes }): ''}`;
        }
        return t('inactiveTooltip');
    }

    return <div style={{ display: 'flex', justifyContent: 'end' }}>
        <StyledTooltip
            title={getIsActiveTooltip()}
            arrow
        >
            <FormControlLabel
                label={t('label')}
                control={<Checkbox
                    checked={isActive}
                    onChange={(event) => onChange(event.target.name, event.target.checked)}
                    name="isActive"
                    color="primary"
                    disabled={isActive && !!settingNamesUsingRule.length} />} />
        </StyledTooltip>
    </div>;
}
